<template>
  <div class="inline-flex items-center cursor-pointer toggle" :class="clsx(className)" @click="toggle">
    <!-- <div
        :class="clsx({
          'bg-[var(--interactive-01)] toggle-active': model,
          'bg-[var(--toggle-bg)]': !model
        })"
        class="relative w-11 h-6 after:start-[2px]  peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-[color:var(--interactive-01)] rounded-full peer border-[color:var(--border-color)] after:content-[''] after:absolute after:top-[2px] after:bg-[var(--inverse-01)] after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
  </div> -->
  <!-- <div
        :class="clsx({
          'bg-[#34C759] toggle-active': model,
          'bg-[var(--toggle-bg)]': !model
        })"
        class="relative w-11 h-6 after:start-[2px]  peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-[color:var(--interactive-01)] rounded-full peer border-[color:var(--border-color)] after:content-[''] after:absolute after:top-[2px] after:bg-[var(--inverse-01)] after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
  </div> -->
  <div
        :class="clsx({
          'bg-[var(--quick-link-icon-bg)] toggle-active': model,
          'bg-[var(--toggle-bg)]': !model
        })"
        class="relative w-11 h-6 after:start-[2px]  peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-[color:var(--interactive-01)] rounded-full peer border-[color:var(--border-color)] after:content-[''] after:absolute after:top-[2px] after:bg-[#fff] after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
  </div>
</template>

<script setup>
import clsx from 'clsx'
const model = defineModel()

const props = defineProps(['className'])
function toggle() {
  model.value = !model.value
}
</script>

<style scoped lang="scss">
.toggle{
  &-active{
    &:after{
      transform: translateX(100%);
    }
  }
}
</style>